import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import * as galleryActions from 'redux/actions/galleryActions';

import Slideshow from 'components/Slideshow/Slideshow';

import './RoomFacilitiesOverlayLayout.desktop.scss';
import './RoomFacilitiesOverlayLayout.mobile.scss';

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isMobileBreakpoint: state.appState.get('isMobileBreakpoint'),
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    galleryActionsBound: bindActionCreators(galleryActions, dispatch),
  };
}

export class RoomFacilitiesOverlayLayout extends Component {
  static propTypes = {
    facilities: ImmutablePropTypes.list,
    galleryActionsBound: PropTypes.object,
    images: PropTypes.object,
    isMobileBreakpoint: PropTypes.bool.isRequired,
    overlayText: PropTypes.string,
    slideWidth: PropTypes.number,
    title: PropTypes.string,
    mainImageType: PropTypes.string,
    thumbnailImageType: PropTypes.string,
    disableThumbnails: PropTypes.bool,
  };

  static defaultProps = {
    disableThumbnails: false,
    facilities: Immutable.List(),
    mainImageType: 'RGXL',
    slideWidth: 500,
    thumbnailImageType: 'RTB',
  };

  render() {
    const {
      facilities,
      galleryActionsBound,
      images,
      isMobileBreakpoint,
      overlayText,
      slideWidth,
      title,
      mainImageType,
      thumbnailImageType,
      disableThumbnails,
    } = this.props;

    const showImages = !!images && !!images.size && !isMobileBreakpoint;
    const modelPaddingLeftAndRight = 50;
    const slideShowSlideWidth = slideWidth - modelPaddingLeftAndRight;
    const hasFacilities = !!facilities && facilities.size > 0;

    return (
      <article className="room-facilities-overlay-layout__facilities-overview">
        { showImages && (
          <div className={`room-facilities-overlay-layout__facilities-overview__slideshow ${!hasFacilities ? 'room-facilities-overlay-layout__facilities-overview__slideshow--no-facilities' : ''}`}>
            <Slideshow
              slideWidth={slideShowSlideWidth}
              images={images}
              overlayText={overlayText}
              toggleControlsAreActive={galleryActionsBound.toggleControlsAreActive}
              mainImageType={mainImageType}
              thumbnailImageType={thumbnailImageType}
              disableThumbnails={disableThumbnails}
            />
          </div>
        )}
        <h3 className="room-facilities-overlay-layout__facilities-overview__title">{title}</h3>
        { hasFacilities && (
          <div className={`room-facilities-overlay-layout__facilities-overview__container-list ${showImages ? 'room-facilities-overlay-layout__facilities-overview__container-list--has-image' : ''}`}>
            <div className="room-facilities-overlay-layout__facilities-overview__list">
              <ul>{ facilities.map((facility, index) => <li key={index}>{facility}</li>) }</ul>
            </div>
          </div>
        ) }
      </article>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoomFacilitiesOverlayLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/RoomFacilitiesOverlayLayout/RoomFacilitiesOverlayLayout.jsx
 **/